import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IAppConfig } from '@app/store/models/config.interface';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { Subject, Subscription, lastValueFrom } from 'rxjs';
import { APP_CONFIG } from 'src/app/modules/core/config/config';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';
import { ErrorCode, ErrorMessage, PublicQrDetails, QrGeneratorNavigatorAPP, QrGeneratorNavigatorBUSINESSPAGE, QrGeneratorNavigatorCategories, QrGeneratorNavigatorCOUPONS, QrGeneratorNavigatorEVENT, QrGeneratorNavigatorFEEDBACK, QrGeneratorNavigatorIMAGES, QrGeneratorNavigatorLOCATION, QrGeneratorNavigatorLONGPLAINTEXT, QrGeneratorNavigatorMEMORIES, QrGeneratorNavigatorMP3, QrGeneratorNavigatorPDF, QrGeneratorNavigatorPET, QrGeneratorNavigatorRATING, QrGeneratorNavigatorRESTAURANTMENU, QrGeneratorNavigatorSOCIALS, QrGeneratorNavigatorVACANCY, QrGeneratorNavigatorVCARDPRO, QrGeneratorNavigatorVIDEOS, QrGeneratorNavigatorWEBSITE, SystemUserTypes } from 'shared-library';
import { PreparedPopupGeneratedRecordInterface } from '@app/store/models/prepared-popup-generated-record.interface';
import { QrRecordTypes } from '@app/store/enums/qr-record-types.enum';
import { Store } from '@ngrx/store';
import { selectAppState } from '@app/store/selectors/app.selectors';
import { AppState } from '@app/store/states/app.states';
import { PublicInformationPageMessageTypes } from '@app/modules/shared/components/public-information-page/public-information-page.enum';
import * as AuthActions from '../../../auth/store/actions/auth.actions'
import { FormBuilder, Validators } from '@angular/forms';
import { SeoService } from '@app/modules/core/services/seo.service';

@Component({
  selector: 'app-qrs-wrapper',
  templateUrl: './qrs-wrapper.component.html',
  styleUrls: ['./qrs-wrapper.component.scss']
})
export class QrsWrapperComponent implements OnInit, OnDestroy {

  short_id: string
  fallback: string
  background_image: string
  error_occurred: ErrorCode
  background_color = "#FFFFFF"

  error_code_keys = {
    PROFILE_NOT_FOUND: { key: 'PROFILE_NOT_FOUND', message_type: PublicInformationPageMessageTypes.QR_NOT_FOUND },
    INACTIVE_PROFILE: { key: 'INACTIVE_PROFILE', message_type: PublicInformationPageMessageTypes.QR_IS_DISABLED },
    MAXIMUM_SCANS_REACHED: { key: 'MAXIMUM_SCANS_REACHED', message_type: PublicInformationPageMessageTypes.QR_VISITS_REACHED },
  }

  social_data: SocialHelper
  session_info: SessionInfo
  qr_details: PublicQrDetails

  ots_error: string
  qr_record_types = {
    QRCODE: QrRecordTypes.QRCODE,
    QROFFTHESHELF: QrRecordTypes.QROFFTHESHELF
  }
  private activation_code_ots_qr = ""
  private subscriptions: Subscription[] = []
  history_obs: Subject<PreparedPopupGeneratedRecordInterface> = new Subject<PreparedPopupGeneratedRecordInterface>()
  all_categories = this.qrService.getAllCategoriesObj()

  app_state: AppState
  appState$ = this.store.select(selectAppState);
  activation_form = this.formBuilder.group({
    error: [""],
    activating: [false],
    recaptcha_token: [""],
    activation_code_ots_qr: ["", Validators.required],
  })

  constructor(
    private store: Store,
    private router: Router,
    private seoService: SeoService,
    private httpClient: HttpClient,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public readonly coreService: CoreService,
    private functionService: FunctionsService,
    private qrService: UserQrGeneratorService,
    @Inject(APP_CONFIG) private readonly config: IAppConfig
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
    this.subscriptions.push(this.appState$.subscribe(ls => this.app_state = ls))
    this.subscriptions.push(this.activation_form.get('activation_code_ots_qr').valueChanges.subscribe(_ => this.activation_form.get('error').setValue("")))
  }

  ngOnInit(): void {
    this.subscriptions.push(this.activatedRoute.params.subscribe(p => {
      this.short_id = p["id"]
      this.getData()
    }))
    this.functionService.initializeTooltip()
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

  private fillResponse(history: PublicQrDetails) {

    switch (history.code_category as QrGeneratorNavigatorCategories) {

      case QrGeneratorNavigatorCategories.APP:
        history.app_data = history.data as QrGeneratorNavigatorAPP
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            description: [history.app_data.headings.meta],
            title_keywords: [`Download ${history.app_data.app.name}`, history.app_data.headings.main]
          })
        }
        break;

      case QrGeneratorNavigatorCategories.BUSINESS_PAGE:
        history.businesspage_data = history.data as QrGeneratorNavigatorBUSINESSPAGE
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.businesspage_data.company],
            description: [history.businesspage_data.headings.main, history.businesspage_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.RESTAURANT_MENU:
        history.restaurant_menu_data = history.data as QrGeneratorNavigatorRESTAURANTMENU
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.restaurant_menu_data.headings.main],
            description: [history.restaurant_menu_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.LONG_PLAIN_TEXT:
        history.long_plain_text_data = history.data as QrGeneratorNavigatorLONGPLAINTEXT
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category)
        }
        break;

      case QrGeneratorNavigatorCategories.COUPONS:
        history.coupons_data = history.data as QrGeneratorNavigatorCOUPONS
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.coupons_data.company_name],
            description: [history.coupons_data.headings.main, history.coupons_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.EVENT:
        history.event_data = history.data as QrGeneratorNavigatorEVENT
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.event_data.headings.main],
            description: [history.event_data.event.organizer, history.event_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.FEEDBACK:
        history.feedback_data = history.data as QrGeneratorNavigatorFEEDBACK
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.feedback_data.company_name],
            description: [history.feedback_data.headings.main, history.feedback_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.IMAGES:
        history.images_data = history.data as QrGeneratorNavigatorIMAGES
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.images_data.headings.main],
            description: [history.images_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.MEMORIES:
        history.memories_data = history.data as QrGeneratorNavigatorMEMORIES
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            description: [history.memories_data.headings.meta],
            title_keywords: [history.memories_data.headings.main]
          })
        }
        break;

      case QrGeneratorNavigatorCategories.MP3:
        history.mp3_data = history.data as QrGeneratorNavigatorMP3
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.mp3_data.headings.main],
            description: [history.mp3_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.PDF:
        history.pdf_data = history.data as QrGeneratorNavigatorPDF
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.pdf_data.company_name],
            description: [history.pdf_data.headings.main, history.pdf_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.RATING:
        history.rating_data = history.data as QrGeneratorNavigatorRATING
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.rating_data.company_name],
            description: [history.rating_data.headings.main, history.rating_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.SOCIAL_MEDIA:
        history.socials_data = history.data as QrGeneratorNavigatorSOCIALS
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.socials_data.headings.main],
            description: [history.socials_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.VACANCY:
        history.vacancy_data = history.data as QrGeneratorNavigatorVACANCY
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.vacancy_data.company_name],
            description: [history.vacancy_data.headings.main, history.vacancy_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.VCARD_PRO:
        history.vcardpro_data = history.data as QrGeneratorNavigatorVCARDPRO
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.vcardpro_data.full_name],
            description: [history.vcardpro_data.summary],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.LOCATION_PLUS:
        history.location_data = history.data as QrGeneratorNavigatorLOCATION
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category)
        }
        break;

      case QrGeneratorNavigatorCategories.PET:
        history.pet_data = history.data as QrGeneratorNavigatorPET
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.pet_data.pet_name],
            description: [history.pet_data.headings.main, history.pet_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.VIDEOS:
        history.videos_data = history.data as QrGeneratorNavigatorVIDEOS
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category, {
            title_keywords: [history.videos_data.company_name],
            description: [history.videos_data.headings.main, history.videos_data.headings.meta],
          })
        }
        break;

      case QrGeneratorNavigatorCategories.WEBSITE:
        history.website_data = history.data as QrGeneratorNavigatorWEBSITE
        if (history.data) {
          this.seoService.generateMetaTags(history.code_category)
        }
        break;

      default:
        break;
    }
    delete history.data

    this.qr_details = history
    this.social_data = {
      description: "",
      qr_url: this.qr_details.qr_url,
      title: this.qr_details.description,
      url: this.functionService.forceUrl(this.qr_details.short_url),
    }

    this.session_info.cache.qr_viewing = this.qr_details
    this.coreService.setSessionData(this.session_info, false)
  }

  private async getData() {
    this.qr_details = null
    const found_in_cache = this.session_info.cache.qr_viewing?.short_id === this.short_id
    if (found_in_cache) {
      this.qr_details = this.session_info.cache.qr_viewing
      this.social_data = {
        description: "",
        qr_url: this.qr_details.qr_url,
        title: this.qr_details.description,
        url: this.functionService.forceUrl(this.qr_details.short_url),
      }
    }

    try {
      const history: PublicQrDetails = (await lastValueFrom(this.httpClient.get(`${this.config.apiEndpoints.qrs.data}${this.short_id}`, { headers: { "skip-message": "true", skip: "true" } })) as { data: PublicQrDetails }).data;
      this.fillResponse(history)

      if (this.qr_details.record_type !== QrRecordTypes.QROFFTHESHELF) {
        if (this.qr_details.code_category === QrGeneratorNavigatorCategories.PDF && this.qr_details.pdf_data.link_directly) {
          if (!found_in_cache) await this.recordClick()
          window.location.replace(this.functionService.forceUrl(this.qr_details.pdf_data.pdf.url))
          return
        }
        if (this.qr_details.code_category === QrGeneratorNavigatorCategories.WEBSITE) {
          if (!found_in_cache) await this.recordClick()
          window.location.replace(this.functionService.forceUrl(this.qr_details.website_data.url))
          return
        }
        if (this.qr_details.code_category === QrGeneratorNavigatorCategories.LOCATION_PLUS) {
          if (!found_in_cache) await this.recordClick()
          window.location.replace(this.functionService.forceUrl(this.qr_details.location_data.url))
          return
        }
      }

      this.history_obs.next(history.popups.popup)
      if (!found_in_cache && this.qr_details.record_type !== QrRecordTypes.QROFFTHESHELF) await this.recordClick()
    } catch (error) {
      this.functionService.logToConsole(error)
      this.error_occurred = error?.message || ErrorMessage.PROFILE_NOT_FOUND
    }
  }

  private clickable() {
    return !(this.qr_details?.team_id && (this.session_info?.user_details?.current_organization_details?.current_team_details?.id === this.qr_details.team_id || this.session_info?.user_details?.user_category === SystemUserTypes.ADMIN || this.qr_details.record_type === QrRecordTypes.QROFFTHESHELF))
  }

  async recordClick() {
    if (!this.clickable()) return
    const click_data = this.qrService.visitInfo()
    try {
      const history: PublicQrDetails = (await lastValueFrom(this.httpClient.post(`${this.config.apiEndpoints.qrs.data}${this.short_id}`, click_data, { headers: { "skip-message": "true", skip: "true" } })) as { data: PublicQrDetails }).data;
      this.fillResponse(history)
    } catch (error) {
      this.functionService.logToConsole(error)
    }
  }

  getOTSFormattedCategory(category: QrGeneratorNavigatorCategories) {
    return this.qrService.getFormattedDynamicQrCategories().find(qrc => qrc.category === category)
  }

  async activateOTS() {

    if (this.qr_details.has_activation_code) {
      this.activation_form.markAllAsTouched()
      if (!this.activation_form.valid || this.activation_form.controls.activating.value) return

      this.activation_form.controls.activating.setValue(true)
      try {
        const recaptcha_token = await this.coreService.getRecaptchaToken()
        const valid = (await lastValueFrom(this.httpClient.patch<{ data: boolean }>(`${this.config.apiEndpoints.qrs.data}${this.short_id}`, { recaptcha_token, activation_code: this.activation_form.controls.activation_code_ots_qr.value }, { headers: { "skip-message": "true", skip: "true" } }))).data;
        if (!valid) {
          this.activation_form.controls.error.setValue("Activation code is invalid!")
          this.activation_form.controls.activating.setValue(false)
          return
        }

        this.activation_code_ots_qr = this.activation_form.controls.activation_code_ots_qr.value
      } catch (error) {
        this.functionService.logToConsole(error)
      }
      this.activation_form.controls.activating.setValue(false)
      this.activation_form.controls.activation_code_ots_qr.setValue("")
    }

    const result = this.qrService.activateOTS(this.coreService, this.session_info, this.qr_details, this.app_state?.currency, this.activation_code_ots_qr)
    if (!result) {
      // Not logged in
      // Navigate to login
      this.store.dispatch(AuthActions.setActivatingOTS({ data: { short_id: this.qr_details.short_id, activation_code_ots_qr: this.activation_code_ots_qr } }))
      this.router.navigateByUrl(`/auth/signup`)
      return
    }
    if (typeof result === typeof "") {
      this.ots_error = result as string
      return
    }
    if (this.coreService.isLoggedIn()) {
      if (this.session_info.user_details.user_category !== SystemUserTypes.USER) {
        this.ots_error = 'Please sign in with a user profile.'
        return
      }
      if (!this.coreService.hasPermission(this.session_info.user_details.user_category + '.USERMANAGEMENT.QRREADNWRITE') &&
        !this.coreService.hasPermission(this.session_info.user_details.user_category + '.USERMANAGEMENT.QRFULLACCESS')) {
        this.ots_error = "Your current logged in profile doesn't have permission to create qr codes."
        return
      }
    }
  }

}

